import {useQuery} from '@tanstack/react-query'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {doCustomAPICall} from '../utils/custom-api-utils'

export const useCustomObject = (params) => {
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const appOrigin = useAppOrigin()
    const customAPIFolderName = 'custom-objects'
    let customObjectId = params?.objectTypeId
    if (params?.objectKey) {
        customObjectId = params?.objectTypeId + '/' + params?.objectKey
    }

    const apiPath = customObjectId + '?'
    const apiParams = {
        config,
        appOrigin,
        customAPIFolderName,
        apiPath,
        reqParams: {
            ...params,
            method: params?.method,
            reqBody: params?.reqBody
        }
    }

    return useQuery({
        queryKey: ['custom', 'custom Objects', customObjectId],
        queryFn: () => doCustomAPICall(getTokenWhenReady, apiParams),
        enabled: !!customObjectId,
        staleTime: 5 * 60000,
        cacheTime: 30 * 60000
    })
}
